import { Component, computed, input } from "@angular/core";
import { QuoteEditModalHelper } from "../QuoteEditModalHelper";
import { QuoteEditAssocGridItem } from "../types/QuoteEditAssocGridItem";
import { MatTableModule } from "@angular/material/table";
import { CommonModule } from "@angular/common";
import { MatFormField, MatInput } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { CommaSeparatedInputComponent } from "../../../components/comma-separated-input/comma-separated-input.component";

@Component({
  selector: 'quote-edit-modal-line-item-assoc-grid',
  templateUrl: 'quote-edit-modal-line-item-assoc-grid.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, MatTableModule, MatFormField, MatInput, CommaSeparatedInputComponent],
})
export class QuoteEditModalLineItemAssocGridComponent {
  private quoteEditModalHelper = new QuoteEditModalHelper();

  public isGridDisabled = input(false);
  public quoteId = input<number>();
  public rows = input<Array<QuoteEditAssocGridItem>>([]);
  public hasDocs = input<boolean>(true);
  public budgetYears = input<number[]>();

  protected Columns = computed(() => this.GetColumns(this.budgetYears() ?? []));

  private GetColumns = (budgetYears: number[]): string[] => [
    "number",
    "external",
    "shortTitle",
    "commercial",
    "objective",
    ...budgetYears.map((a) => "by_" + a),
    "totalCommitted",
    "currency",
    "status",
    "comment"
  ];

  protected GetRowTotalCommitted = (row: QuoteEditAssocGridItem) => [
    ...row.BudgetYears
      .filter((a) => a.QuotedAmount > 0) // only get filled in quoted amounts
      .map((a) => Number(a.QuotedAmount)), // convert the quoted amounts to number (since they would be strings from the input boxes)
    0 // provide at least a 0 to add if no values exist
  ].reduce((a, b) => a + b); // add them all together

  protected CanEditComment(row: QuoteEditAssocGridItem) {
    // return true if any budget year cell is filled in for this quote
    return row.BudgetYears.find((by) => this.quoteEditModalHelper.IsQuotedAmountForThisQuote(this.quoteId(), by));
  }

  protected ShouldRowCellBeLocked(row: QuoteEditAssocGridItem, budgetYear: number): boolean {
    const cell = row.BudgetYears.find((a) => a.BudgetYear === budgetYear);

    if (!cell || this.isGridDisabled() || cell.IsLocked) return true;

    // look up all quoted amounts
    const quotedCurrencies: string[] = [];
    const quotedItemTypes: number[] = [];
    this.rows().forEach((row) => {
      row.BudgetYears.filter((by) => this.quoteEditModalHelper.IsQuotedAmountForThisQuote(this.quoteId(), by)).forEach((by) => {
        quotedCurrencies.push(row.CurrencyName);
        quotedItemTypes.push(row.ItemType);
      });
    });

    // Make sure you can only enter values for 1 currency or item type (i.e., trials or non-trials)
    const quotedCurrency = quotedCurrencies.length > 0 ? quotedCurrencies[0] : row.CurrencyName; 
    const quotedItemType = quotedItemTypes.length > 0 ? quotedItemTypes[0] : row.ItemType;

    return quotedCurrency !== row.CurrencyName || quotedItemType !== row.ItemType;
  }
}
